import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { connect } from "react-redux";
import { compose } from "redux";
import Grid from '@material-ui/core/Grid';
import { fetchUsers } from "../actions/UserAction"

const CustomTableCell = withStyles(theme => ({
  head: {
    //backgroundColor: theme.palette.common.black,
    color: "#2926ac",
    fontWeight:"bold",
    fontSize: 13
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  button: {
    margin: theme.spacing.unit,
    textTransform: "none"
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});


class User extends Component {
    constructor(){
        super()
        this.state={
        }
    }

    componentDidMount(){
      this.props.dispatch(fetchUsers());
    }
 
    
    render() {
        const { classes } = this.props;
      
        return (
            <div className={classes.root}>
             <Grid  spacing={12}>
                <Table className={classes.table}>
                    <TableHead>
                    <TableRow>
                        <CustomTableCell>First Name</CustomTableCell>
                        <CustomTableCell align="left">Last Name</CustomTableCell>
                        <CustomTableCell align="left">Email</CustomTableCell>
                        <CustomTableCell align="left">Role</CustomTableCell>
                        <CustomTableCell align="left">Status</CustomTableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {this.props.users.map(row => (
                        <TableRow className={classes.row} key={row.id}>
                          <CustomTableCell component="th" scope="row">
                              {row.first_name} 
                          </CustomTableCell>
                          <CustomTableCell align="left">{row.last_name}</CustomTableCell>
                          <CustomTableCell align="left">{row.email}</CustomTableCell>
                          <CustomTableCell align="left">{row.user_type}</CustomTableCell>
                          <CustomTableCell align="left" style={{textTransform: 'capitalize'}}>{row.status !== null ? row.status.toLowerCase() : '-'}</CustomTableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>         
              </Grid>
            </div>
        );
    }
}


User.propTypes = {
    classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
    return {
        defaultRole: state.SessionReducer.defaultRole,
        users:state.UserReducer.users
      }
}

export default compose(withStyles(styles),connect(mapStateToProps))(User);